import { ChangeDetectionStrategy, Component, Input, ViewEncapsulation } from '@angular/core';
import { ColumnComponent } from '../column.component';

@Component({
  selector: 'app-column-producer',
  templateUrl: './column-producer.component.html',
  styleUrls: ['./column-producer.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  standalone: false
})
export class ColumnProducerComponent extends ColumnComponent {
  @Input() useNgContent: boolean;
}
